import { useEffect, useContext, useId } from 'react';

import SelectContext from './selectContext';

export default function useParentSelection(isThisSelected) {
  const id = useId();
  const { setIsChildSelected } = useContext(SelectContext);

  useEffect(() => {
    setIsChildSelected(id, isThisSelected);
  }, [id, isThisSelected]);
}
